module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d71f8d3c085db74f2418d62915e6977a.png";